<template>
    <div class="card shadow-sm rounded-3">
      <div class="card-body">
        <!-- Título -->
        <div class="mb-4">
          <h6 style="background: #0078be!important;" class="card-title bg-primary text-white w-100 p-1 mb-3">
                      LISTADO DE PATROCINADORES
                  </h6>
        </div>
  
        <!-- Formulario -->
        <form @submit.prevent="addEjecutivo" class="row g-3 mb-4">
          <div class="col-md-6">
            <label class="form-label fw-semibold">Nombres:</label>
            <input
              v-model="displayName"
              type="text"
              class="form-control text-uppercase"
              placeholder="Ingrese el nombre"
              required
              autocomplete="off"
            />
          </div>
  
          
  
          <div class="col-12 text-end">
            <button
              :disabled="adding"
              id="btn-add"
              type="submit"
              class="btn btn-primary"
            >
              <i class="fas fa-plus me-2"></i>
              {{ adding ? "Agregando..." : "Agregar" }}
            </button>
          </div>
        </form>
  
        <!-- Encabezado listado -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 class="mb-0 fw-bold">
            <i class="fas fa-list me-2"></i>
          </h6>
          <i
            v-if="!loading"
            class="fas fa-sync-alt text-secondary"
            style="cursor: pointer"
            @click="fetchPatrocinadores"
          ></i>
          <Skeletor v-else :shimmer="true" height="20" width="20px" />
        </div>
  
        <!-- Tabla / Skeleton -->
        <div v-if="loading">
          <Skeletor :shimmer="true" height="40" width="100%" class="mb-2" />
          <Skeletor :shimmer="true" height="200" width="100%" />
        </div>
  
        <DataTable
          v-else
          :columns="columns"
          :data="transactions"
          :options="options"
          class="table table-hover"
        >
          <thead class="table-light">
            <tr>
              <th style="width: 40px">#</th>
              <th style="width: 140px">Fecha</th>
              <th style="width: 450px">Nombres</th>
            </tr>
          </thead>
        </DataTable>
      </div>
    </div>
  </template>
  
  <script>
  import $ from "jquery";
  import DataTable from "datatables.net-vue3";
  import DataTablesCore from "datatables.net-bs5";
  import "datatables.net-responsive";
  
  DataTable.use(DataTablesCore);
  
  export default {
    name: "ProvidersAdmin",
    components: { DataTable },
    props: ["tokenAuth"],
    data() {
      return {
        loading: true,
        adding: false,
        displayName: "",
        email: "",
        transactions: [],
        columns: [
          {
            data: null,
            render: (data, type, row, meta) => meta.row + 1,
          },
          { data: "dateFormatted" },
          { data: "displayName" }
        ],
        options: {
          responsive: true,
          ordering: false,
          columnDefs: [
            { responsivePriority: 1, targets: 0 },
            { responsivePriority: 2, targets: -1 },
          ],
          lengthMenu: [
            [5, 15, 25, 50, -1],
            [5, 15, 25, 50, "Todos"],
          ],
          pageLength: 5,
          language: {
            search: "Buscar:",
            sInfo: "Mostrando registros del _START_ al _END_ de _TOTAL_",
            sInfoEmpty: "Mostrando 0 registros",
            searchPlaceholder: "Ingrese algún dato",
            zeroRecords: "No se encontraron resultados",
            processing: "Procesando...",
            sLengthMenu: "Mostrar _MENU_ registros",
            oPaginate: {
              sFirst: "Primero",
              sLast: "Último",
              sNext: "Siguiente",
              sPrevious: "Anterior",
            },
          },
        },
      };
    },
    methods: {
      addEjecutivo() {
        this.adding = true;
        const btn = document.getElementById("btn-add");
        btn.innerHTML = '<i class="fas fa-spinner fa-pulse"></i> Agregando...';
  
        this.$https
          .post("/ejecutivos/addPartners", {
            displayName: this.displayName.toUpperCase()
          })
          .then((res) => {
            this.$toast.success(res.data.message);
            this.displayName = "";
            this.fetchPatrocinadores();
          })
          .catch((err) => {
            this.$toast.error(err.response?.data?.error || "Error");
          })
          .finally(() => {
            this.adding = false;
            btn.innerHTML = '<i class="fas fa-plus me-2"></i> Agregar';
          });
      },
  
      fetchPatrocinadores() {
        // Aquí puedes poner la lógica para volver a cargar los ejecutivos
        this.loading = true;
        this.$https
          .post("ejecutivos/loadPartners", {
            tokenAuth: this.tokenAuth,
          })
          .then((response) => {
            this.loading = false;
            this.transactions = response.data.partners;
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error(error.data.message, {
              position: "top-right",
              max: 10,
            });
          });
      },
    },
    mounted() {
      $(document).off("click", ".activarSwitch");
      $(document).on("click", ".activarSwitch", (evt) => {
        const providerDni = $(evt.target).data("providerdni");
        const isActive = $(evt.target).prop("checked");
        this.providerStatus = isActive;
        this.providerDni = providerDni;
      });
  
  
      this.fetchPatrocinadores()
  
  
    },
  };
  </script>
  
  <style lang="scss">
  @import "datatables.net-dt";
  @import "datatables.net-responsive-dt";
  </style>
  